import ServiceIcon from '../../../assets/images/service-dummy-icon.png';
import teamMemberOne from '../../../assets/images/TeamMemberOne.jpg';
import teamMemberTwo from '../../../assets/images/TeamMemberTwo.jpg';
import teamMemberThree from '../../../assets/images/TeamMemberThree.jpg';
import CourtTax from '../../../assets/images/svg/taxes-stroke.svg';
import precise from '../../../assets/images/svg/precise.svg';
import digital from '../../../assets/images/svg/digital.svg';
import protect from '../../../assets/images/svg/protect.svg';
import data from '../../../assets/images/svg/data.svg';
import forCorpate from '../../../assets/images/for-corporates.png';
import forLawFirms from '../../../assets/images/for-law-firms.png';
import forIndividuals from '../../../assets/images/for-individuals.png';
import lawFirms from '../../../assets/images/svg/lawFirms.svg';
import individuals from '../../../assets/images/svg/individuals.svg';
import independentCounsels from '../../../assets/images/svg/independentCounsels.svg';
import corporates from '../../../assets/images/svg/corporates.svg';
import AIRapid from '../../../assets/images/svg/AIRapid.svg';
import AICase from '../../../assets/images/svg/AICase.svg';
import AICustom from '../../../assets/images/svg/AICustom.svg';
import AiPowered from '../../../assets/images/svg/aiPowered.svg';
import SmartLegal from '../../../assets/images/svg/smartLegal.svg';
import Comprehensive from '../../../assets/images/svg/comprehensive.svg';
import Contract from '../../../assets/images/svg/contract.svg';
import Judgement from '../../../assets/images/svg/judgement.svg';
import CaseManagement from '../../../assets/images/svg/caseManagement.svg';
import Consultation from '../../../assets/images/svg/consultation.svg';
import Litigation from '../../../assets/images/svg/litigation.svg';
import Property from '../../../assets/images/svg/property.svg';

interface Service {
  id: number;
  title: string;
  subtitle: string;
  image: string;
  cards: Array<{
    icon: string;
    title: string;
  }>;
}

export const servicesData: Service[] = [
  {
    id: 1,
    title: 'For Corporates',
    subtitle: 'Advanced artificial intelligence for comprehensive legal analysis',
    image: forCorpate,
    cards: [
      {
        icon: AIRapid,
        title: 'Legal Consultation & Strategic Advisory',
      },
      {
        icon: AICase,
        title: 'Comprehensive Compliance Management',
      },
      // {
      //   icon: AICustom,
      //   title: 'Regulatory Updations',
      // },
      {
        icon: AICustom,
        title: 'Training & Awareness Programs',
      },
    ],
  },
  {
    id: 2,
    title: 'For Law Firms & Legal Professionals',
    subtitle: 'Intelligent document creation with precision and expertise',
    image: forLawFirms,
    cards: [
      {
        icon: AiPowered,
        title: 'AI-Powered Legal Research',
      },
      {
        icon: SmartLegal,
        title: 'Smart Legal Drafting',
      },
      {
        icon: Comprehensive,
        title: 'Comprehensive Litigation Support',
      },
      {
        icon: Contract,
        title: 'Contract Vetting & Document Scrutiny',
      },
      {
        icon: Judgement,
        title: 'Current Judgment Updates',
      },
      {
        icon: CaseManagement,
        title: 'Case Management Tools',
      },
    ],
  },
  {
    id: 3,
    title: 'For Individuals',
    subtitle: 'Expert legal advice and strategic consultation services',
    image: forIndividuals,
    cards: [
      {
        icon: Consultation,
        title: 'Legal Consultation',
      },
      {
        icon: Litigation,
        title: 'Litigation & Non-Litigation Support',
      },
      {
        icon: Property,
        title: 'Property Conveyances & Opinions',
      },
    ],
  },
];

interface ExpertiseCard {
  id: number;
  title: string;
  description: string;
}
export const expertiseData: ExpertiseCard[][] = [
  [
    {
      id: 1,
      title: 'Cyber Law',
      description:
        'As a LegalTech company, we bridge the gap between law and technology to offer robust support in Cyber Law. From data privacy and cybercrime to digital contracts and compliance, our tech-driven legal solutions help businesses stay secure, compliant, and prepared in the digital age.  ',
    },
    {
      id: 2,
      title: 'Customs Law',
      description:
        'With over 20 years of specialized experience in Customs Law, we provide expert guidance on import-export regulations, compliance, duty structures, and dispute resolution. Our legal insights, combined with technology-driven tools, ensure seamless cross-border operations and regulatory adherence.',
    },
    {
      id: 3,
      title: 'GST',
      description:
        'We combine deep legal expertise with advanced AI to simplify and streamline GST compliance. Our AI-powered tools deliver precise insights, reduce errors, and optimize tax positions through intelligent automation',
    },

    {
      id: 4,
      title: 'Corporate Law',
      description:
        "We leverage cutting-edge AI to provide comprehensive legal counsel in Corporate Law, enabling businesses to thrive within India's dynamic regulatory landscape. We empower businesses to manage legal complexities and maintain regulatory compliance with confidence ",
    },
  ],
];

export const reasons = [
  {
    id: 1,
    icon: precise,
    text: 'We combine 20 years of legal experience with 15 years of technology expertise to deliver unparalleled techno-legal solutions.',
  },
  {
    id: 2,
    icon: digital,
    text: 'Every task is reviewed by both our advanced AI and our expert legal professionals, ensuring the output is not just fast—but legally sound.',
  },
  {
    id: 3,
    icon: protect,
    text: 'We offer tailored, cost-efficient packages and solutions designed to meet the unique needs of corporates, law firms, and individuals',
  },
  {
    id: 4,
    icon: data,
    text: 'Our purpose is to help businesses navigate complex legal landscapes and proactively mitigate legal and cyber risks.',
  },
  // {
  //   id: 5,
  //   icon: data,
  //   text: 'Cost efficient packages based on the work. ',
  // },
  // {
  //   id: 6,
  //   icon: data,
  //   text: 'Data driven legal drafting. ',
  // },
];
interface TargetAudience {
  id: number;
  icon: string;
  title: string;
  description: string;
}
export const targetAudiences: TargetAudience[] = [
  {
    id: 1,
    icon: corporates,
    title: 'Corporates',
    description:
      'We support corporate clients by acting as a dedicated legal consultant across all legal matters. We provide Al assisted, expert-reviewed services that help in-house teams save time, reduce legal risks, and ensure business decisions are legally sound.',
  },
  {
    id: 2,
    icon: lawFirms,
    title: 'Law Firms',
    description:
      'Legalligence offers AI-assisted legal research and smart drafting services, help save time and enhance efficiency. Every document is carefully reviewed by senior legal experts with over 20 years of experience, ensuring accuracy, compliance, and trust. ',
  },
  {
    id: 3,
    icon: independentCounsels,
    title: 'Independent counsels',
    description:
      'We empower independent lawyers by handling time-consuming legal research and drafting tasks with the support of AI. This allows solo practitioners to deliver high-quality work faster, take on more clients, and focus on strategic legal thinking.',
  },

  {
    id: 4,
    icon: CourtTax,
    title: 'Compliance teams in enterprises',
    description:
      'We assist enterprise compliance teams by delivering Al-assisted legal research, documentation, and regulatory analysis tailored to industry-specific requirements.',
  },
  {
    id: 5,
    icon: individuals,
    title: 'Individuals',
    description:
      'We support individuals by offering legal advice and consultations to help them take the right legal steps with confidence.',
  },
];

interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'Arnold Schwarzenegger',
    role: 'Lawyer',
    image: teamMemberOne,
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    role: 'Senior Partner',
    image: teamMemberTwo,
  },
  {
    id: 3,
    name: 'David Thompson',
    role: 'Legal Consultant',
    image: teamMemberThree,
  },
];
interface AboutData {
  count: number;
  label: string;
}
export const AboutData = [
  { count: 1037, label: 'Projects' },
  { count: 156, label: 'Clients' },
  { count: 90, label: 'Tasks Completed', suffix: '%' },
  { count: 23, label: 'Tasks Completed', suffix: '+' },
];
